/**
 * Compara dois objetos de filtros profundamente
 * Retorna true se forem iguais, false caso contrário
 */
export const compararFiltrosProfundo = (filtros1, filtros2) => {
  // Se ambos são null/undefined, são iguais
  if (!filtros1 && !filtros2) return true;
  if (!filtros1 || !filtros2) return false;
  
  const keys1 = Object.keys(filtros1);
  const keys2 = Object.keys(filtros2);
  
  if (keys1.length !== keys2.length) return false;
  
  for (const key of keys1) {
    const val1 = filtros1[key];
    const val2 = filtros2[key];
    
    // Comparar arrays
    if (Array.isArray(val1) && Array.isArray(val2)) {
      if (val1.length !== val2.length) return false;
      const sorted1 = [...val1].sort();
      const sorted2 = [...val2].sort();
      for (let i = 0; i < sorted1.length; i++) {
        if (sorted1[i] !== sorted2[i]) return false;
      }
    } else if (val1 !== val2) {
      return false;
    }
  }
  
  return true;
};

/**
 * Cria uma versão estável (serializada) dos filtros para usar como dependência
 * Retorna uma string que só muda quando o conteúdo dos filtros muda
 */
export const serializarFiltros = (filtros) => {
  if (!filtros) return '';
  
  const keys = Object.keys(filtros).sort();
  const partes = keys.map(key => {
    const valor = filtros[key];
    if (Array.isArray(valor)) {
      return `${key}:${[...valor].sort().join(',')}`;
    }
    return `${key}:${valor}`;
  });
  
  return partes.join('|');
};
